import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe"]
  static values = {
    url: String,
    page: { type: Number, default: 1 },
    search: { type: String, default: "" }
  }

  load() {
    if (this.loaded) return
    if (!this.urlValue) return
    this.loaded = true
    this.iframeTarget.src = this.#buildUrl()
  }

  navigate({ page, search }) {
    this.pageValue = page || 1
    this.searchValue = search || ""

    if (!this.loaded) {
      this.load()
    } else {
      this.iframeTarget.src = this.#buildUrl()
    }
  }

  #buildUrl() {
    const viewerUrl = new URL("/pdfjs/viewer.html", window.location.origin)
    viewerUrl.searchParams.set("file", this.urlValue)
    if (this.pageValue > 1) viewerUrl.searchParams.set("page", this.pageValue)
    if (this.searchValue) viewerUrl.searchParams.set("search", this.searchValue)
    return viewerUrl.toString()
  }
}
